// ...existing code...
import React, { useEffect, useRef, useState } from "react";
import ReturnLoading from "./components/ReturnLoading";
import { useLocation } from "react-router-dom";
import ReturnDefaultErr from "./components/ReturnDefault";

export default function RedirectPage() {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const pollTimerRef = useRef(null);
  const returnUrl = process.env.REACT_APP_API_RETURN_URL;
  const location = useLocation();
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const langSring = queryParams.get("lang") || "en";
    setLang(["en", "mm", "ch"].includes(langSring) ? langSring : "en");
  }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const merchOrderId = params.get("merch_order_id") ?? params.get("merchOrderId") ?? params.get("RequestID");

    if (!merchOrderId) {
      setError("No merch_order_id found in URL");
      setLoading(false);
      return;
    }

    let mounted = true;
    const controller = new AbortController();

    const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

    const fetchRedirectUrl = async () => {
      try {
        const res = await fetch(`${returnUrl}/${encodeURIComponent(merchOrderId)}`, {
          signal: controller.signal,
        });

        const data = await res.json().catch(() => null);

        if (!res.ok) {
          const msg = data?.message || data?.error || `Failed to fetch URL (${res.status})`;
          if (mounted) {
            setError(msg);
            setLoading(false);
          }
          return;
        }

        const url =
          data?.body?.data?.returnUrl ??
          data?.data?.returnUrl ??
          data?.returnUrl ??
          null;

        if (typeof url === "string" && url.length > 0) {
          if (mounted) {
            setRedirectUrl(url);
            // optional small delay for UX before redirecting
            await sleep(650);
            // attempt direct replace to go back to merchant
            window.location.replace(url);
          }
        } else {
          // Not ready yet -> poll again in 3s
          pollTimerRef.current = window.setTimeout(fetchRedirectUrl, 3000);
        }
      } catch (e) {
        if (e?.name === "AbortError") return;
        if (mounted) {
          setError("Failed to fetch URL");
          setLoading(false);
        }
      }
    };

    fetchRedirectUrl();

    return () => {
      mounted = false;
      controller.abort();
      if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
    };
  }, [location.search, returnUrl]);

  const handleConfirm = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  if (loading) {
    return <ReturnLoading lang={lang} />;
  }

  return (
    <ReturnDefaultErr err={error} returnUrl={redirectUrl}/>
  );
}
